// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see RecurringPaymentCancelStartEvent
 */
export var RecurringPaymentCancelStart = function (_a) {
    var recurringPaymentToken = _a.recurringPaymentToken, type = _a.type, senderCustomerToken = _a.senderCustomerToken, recipientCustomerToken = _a.recipientCustomerToken, reason = _a.reason;
    return ({
        name: "RecurringPayment Cancel Start",
        parameters: {
            cdf_entity: "RecurringPayment",
            cdf_action: "Cancel",
            recurring_payment_token: recurringPaymentToken !== undefined && recurringPaymentToken !== null ? recurringPaymentToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sender_customer_token: senderCustomerToken !== undefined && senderCustomerToken !== null ? senderCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            recipient_customer_token: recipientCustomerToken !== undefined && recipientCustomerToken !== null ? recipientCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
